<section class="responsive-card d-flex flex-column" [style.gap.rem]="2" aria-labelledby="vb-overview-heading">
  <button
    type="button"
    class="no-style-button"
    aria-label="Toggle Variable Benefit details"
    i18n-aria-label
    (click)="collapse.toggle()">
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex gap-2 align-items-center">
        <img
          src="assets/icons/grey/Chevron%20Down.svg"
          class="chevron"
          [class.expanded]="!isCollapsed"
          alt=""
          [style.height.rem]="1.5"
          [style.width.rem]="1.5" />
        <span id="vb-overview-heading" class="overview-card-header" i18n>Variable Benefit</span>
      </div>
      <app-primary-button
        i18n
        [size]="BaseButtonSizeEnum.xs"
        [disabled]="disableUpdateButton"
        rightIconSrc="assets/icons/white/Chevron Right.svg"
        (click)="$event.stopPropagation(); updatePayments.emit()"
        >Update</app-primary-button
      >
    </div>
  </button>
  <app-system-banner *ngIf="banner" [banner]="banner" (textButtonClicked)="goToSubmission.emit()" />
  <div [(ngbCollapse)]="isCollapsed" #collapse="ngbCollapse">
    <div>
      <ng-content />
    </div>
  </div>
</section>
